// @ts-strict-ignore
import { createSelector } from 'reselect';

import { JA_TERMINAL_OUTCOME_STATES } from '~/application-review/constants';
import type { State } from '~/store';

export const selectAssignableAgents = (state: State) => state.investigations.assignableAgents;

export const selectInvestigationQueue = (state: State) => state.investigations.queue;

export const selectInvestigationDetail = (state: State) => state.investigations.investigation;

export const selectInvestigationFilters = (state: State) => state.investigations.queue.filters;

export const selectInvestigationFetched = (
  state: State,
) => state.investigations.fetched;

export const selectCanInvestigationBeClosed = createSelector(
  [
    (state: State) => state.investigations.investigation.journeyAlertsByToken,
  ],
  (journeyAlertsByToken = {}) => (
    !Object.values(journeyAlertsByToken).some(journeyAlert => (
      !JA_TERMINAL_OUTCOME_STATES.includes(journeyAlert.journeyApplicationState)
    ))
  ),
);

export const selectAlertManualReview = (alertManualReviewToken?: string) => (state: State) => (
  state.investigations.investigation?.alertManualReviewsByToken?.[alertManualReviewToken] ?? null
);

export const selectManualReviewsByAlertToken = (
  alertTokens?: string[],
) => (state: State) => (
  alertTokens.reduce((acc, alertToken) => {
    const alertManualReviewToken = state.investigations.investigation
      .journeyAlertsByToken[alertToken]?.journeySteps[0]?.review?.alertManualReviewToken
      ?? null;

    const alertManualReview = state.investigations.investigation
      ?.alertManualReviewsByToken?.[alertManualReviewToken]
      ?? null;

    return {
      ...acc,
      [alertToken]: alertManualReview,
    };
  }, {})
);

export const selectAlertEvaluation = (evaluationToken?: string) => (state: State) => (
  state.investigations.investigation?.evaluationsByToken?.[evaluationToken] ?? null
);

export const selectJourneyActions = (state: State) => (
  state.investigations.investigation.journeyActions
);

export const selectOutcomes = (state: State) => state.investigations.investigation.outcomes;

export const selectReasons = (state: State) => state.investigations.investigation.reasons;
